export default "__VITE_ASSET__DHrv_lMJ__"